import { atom } from 'recoil';

export const bslbrPartnersAtom = atom({
    key: 'bslbrPartnersAtom',
    default: [] as { value: string; text: string }[]
});

export const bslbrCountriesAtom = atom({
    key: 'bslbrCountriesAtom',
    default: [] as { value: string; text: string }[]
});

export const bslbrPartsAtom = atom({
    key: 'bslbrPartsAtom',
    default: [] as {
        CreatedAt: string;
        Description: string;
        FinalPrice: string;
        Id: number;
        ListPrice: string;
        PartNumber: string;
        UpdatedAt: string;
    }[]
});

export const bslbrPartsQuotation = atom({
    key: 'bslbrPartsQuotation',
    default: [] as {
        Id?: string;
        PartNumber: string;
        PartNumberDescription: string;
        PriceItem: number;
        Quantity: number;
        TotalPriceItem: number;
        TotalPrice?: string;
    }[]
});
